import React, { FunctionComponent } from 'react';
import { Modal } from 'semantic-ui-react';
import ReactJson, { OnCopyProps } from 'react-json-view';
import { useTranslation } from 'react-i18next';
import { ModalProps } from '../../../types/ModalProps';

export const InstantLeaseCustomerModalComponent: FunctionComponent<ModalProps> = ({
    showModal = false,
    onClose,
    data,
}) => {
    const { t } = useTranslation();

    const copyFun = (copy: OnCopyProps): void => {
        if (typeof copy.src === 'string') {
            let jsonChild = copy.src as string;
            jsonChild = jsonChild.replaceAll('"', '');
            navigator.clipboard.writeText(jsonChild);
        }
    };

    return (
        <Modal open={showModal} size={'fullscreen'} closeOnEscape={true} closeOnTriggerBlur={true} onClose={onClose}>
            <Modal.Header>{t('lead.detail.box.customer.instantLeaseCustomer')}</Modal.Header>
            <Modal.Content scrolling={true}>
                <ReactJson src={data} displayDataTypes={false} enableClipboard={copyFun} sortKeys={true}></ReactJson>
            </Modal.Content>
        </Modal>
    );
};
